export const GET_AIR_PORTS = "GET_AIR_PORTS";
export const GET_AIR_PORT = "GET_AIR_PORT";
export const ADD_AIR_PORT = "ADD_AIR_PORT";
export const DELETE_AIR_PORT = "DELETE_AIR_PORT";
export const UPDATE_AIR_PORT = "UPDATE_AIR_PORT";
